import React, { useEffect } from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import _ from "underscore";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { SizeSwitch } from "Common/Responsive";
import Button from "Theme/Button";

import SavedPlanBox from "./savedPlansTray/SavedPlanBox";

import makeBem from "Utils/makeBem";

const bem = makeBem("SavedPlansTray");
export const MAX_SAVED_PLANS = 4;

const SavedPlansTray = ({
  downloadDecisionPacketURL,
  comparePageURL,
  onClickCompareLink,
  onClickClearAllLink,
  plans = [],
  planIDs,
  plansLoading,
  onToggleSavePlan,
  shouldShowSimplePlanName,
  showMobileCompare,
}) => {
  // Note: map over planIds, not indexes - plan details may still be loading
  const savedPlanBoxes = planIDs
    .slice(0, MAX_SAVED_PLANS)
    .map((planID, index) => (
      <SavedPlanBox
        key={index}
        plan={plans[index]}
        planID={planID}
        isLoading={plansLoading[index]}
        toggleSavePlan={onToggleSavePlan}
        shouldShowSimplePlanName={shouldShowSimplePlanName}
      />
    ));
  useEffect(() => {
    const helpButton = document.querySelector(".helpButton");

    if (helpButton) {
      helpButton.style.bottom = "126px";
    }

    return () => {
      const helpButton = document.querySelector(".helpButton");

      if (helpButton) {
        helpButton.style.bottom = "12px";
      }
    };
  }, []);

  const renderForStandardDesktop = () => (
    <Grid p={4} className={bem("Container", "desktop")}>
      <Div className={bem("Controls")}>
        <Button
          onDarkBackground
          fullWidth
          size={isIntuit() ? "medium" : undefined}
          onClick={onClickCompareLink}
          className={bem("CompareButton")}
          component={Link}
          to={comparePageURL}
        >
          Compare
        </Button>
      </Div>
      <Div mx={3} className={bem("PlanBoxes")}>
        {savedPlanBoxes}
      </Div>
      <Div>
        <Icon role="Clear" size="2x" icon="circle-xmark" flavor="solid" className={bem("ClearAllButton")} onClick={onClickClearAllLink} />
      </Div>
    </Grid>
  );

  const renderForMobile = () => (
    <Div p={3} px={4} className={bem("Container", "desktop")}>
      <Div className={bem("PlanBoxes")}>{savedPlanBoxes}</Div>
      <Div className={bem("Controls")}>
        <Button onDarkBackground fullWidth size={isIntuit() ? "medium" : undefined} onClick={onClickCompareLink} component={Link} to={comparePageURL}>
          Compare Plans
        </Button>
      </Div>
      {/**
       * FUTURE: Verify product approved suggestion of clear all button
       * @see https://www.figma.com/file/si47YHwYGS0Mdh88BCAK50?node-id=310:30612&mode=dev#665062606
       */}
    </Div>
  );

  return (
    <div
      className={classnames(bem(), {
        [bem(null, "intuit")]: isIntuit(),
      })}
    >
      <SizeSwitch xs={showMobileCompare ? renderForMobile() : null} sm={renderForStandardDesktop()} />
    </div>
  );
};

SavedPlansTray.propTypes = {
  plans: PropTypes.array.isRequired,
  plansLoading: PropTypes.arrayOf(PropTypes.bool).isRequired,
  onClickCompareLink: PropTypes.func.isRequired,
  onClickClearAllLink: PropTypes.func.isRequired,
  onToggleSavePlan: PropTypes.func.isRequired,
  showMobileCompare: PropTypes.bool.isRequired,
};
export default SavedPlansTray;
